export default __webpack_public_path__ + "static/media/artist.f29144fc.jpg";